import React from 'react';
import { Multiselect, DropdownList } from 'react-widgets';
import Immutable from 'immutable';

function renderWarning(touched, error) {
  if (!(touched && error)) {
    return;
  }

  if (error === true) {
    return;
  }

  return (
    <div className="alert alert-danger" role="alert">
      {error}
    </div>
  );
}

/**
 * Renders react-widgets Multiselect component, converting inputs
 * from Immutable if necessary
 * @param  {[type]} field [description]
 * @return {[type]}       [description]
 */
const renderMultiselect = field => {
  // field has read-only properties so let's copy it first, then translate from Immutable
  field = Object.assign({}, field);
  if (Immutable.Iterable.isIterable(field.meta.initial)) {
    field.meta.initial = field.meta.initial.toJS();
  }
  if (Immutable.Iterable.isIterable(field.input.value)) {
    field.input.value = field.input.value.toJS();
  }
  if (Immutable.Iterable.isIterable(field.data)) {
    field.data = field.data.toJS();
  }
  const { meta } = field;
  return (
    <React.Fragment>
      <Multiselect
        {...field.input}
        onBlur={() => field.input.onBlur()}
        value={field.input.value || []}
        data={field.data}
        valueField={field.valueField}
        textField={field.textField}
        messages={field.messages}
        placeholder={field.placeholder}
      />
      {renderWarning(meta.touched, meta.error)}
    </React.Fragment>
  );
};

const renderDropdownList = field => {
  // field has read-only properties so let's copy it first, then translate from Immutable
  field = Object.assign({}, field);
  if (Immutable.Iterable.isIterable(field.meta.initial)) {
    field.meta.initial = field.meta.initial.toJS();
  }
  if (Immutable.Iterable.isIterable(field.input.value)) {
    field.input.value = field.input.value.toJS();
  }
  if (Immutable.Iterable.isIterable(field.data)) {
    field.data = field.data.toJS();
  }
  const { meta } = field;
  return (
    <React.Fragment>
      <DropdownList
        filter="contains"
        {...field.input}
        data={field.data}
        valueField={field.valueField}
        textField={field.textField}
        onChange={e =>
          field.input.onChange(typeof e === 'string' ? e : e[field.valueField])}
      />
      {renderWarning(meta.touched, meta.error)}
    </React.Fragment>
  );
};

export default {
  renderMultiselect,
  renderDropdownList
};



// WEBPACK FOOTER //
// ./src/modules/misc/components/Widgets.js